import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDividerDotted12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconDividerDotted12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.5 1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 2.5 0h7A1.5 1.5 0 0 1 11 1.5v2a.5.5 0 0 1-1 0v-2a.5.5 0 0 0-.5-.5zm0 10a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 2.5 12h7a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2a.5.5 0 0 1-.5.5zM6 6.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M4.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M2 6.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M8.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDividerDotted12);
